import { PieceSlider, PieceDescription, PieceUnorderedList } from '@store/index';
const PUBLIC_URL = process.env.REACT_APP_URL;

const jobManagementPlatform = {
    name: 'Job management platform',
    slug: 'job-management-platform',
    description: 'Startup project that helps to simplify hiring process for employer and helps job seekers to find a job. Developed Admin/Employer/Candidate interfaces.',
    cover: {
        url: `${PUBLIC_URL}/portfolio/job-management/cover.jpg`,
        license: {
            link: 'http://www.freepik.com',
            text: 'Designed by makyzz / Freepik'
        }
    },
    prominentColor: 'rgb(236,180,114)',
    pieces: [
        {
            type: 'slider',
            images: [
                {
                    url: `${PUBLIC_URL}/portfolio/job-management/process.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by macrovector / Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/job-management/vacancy.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/job-management/talent.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/job-management/cover.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by makyzz / Freepik'
                    }
                }
            ]
        } as PieceSlider,
        {
            type: 'description',
            title: 'Role',
            description: 'Front-End developer',
        } as PieceDescription,
        {
            type: 'unordered list',
            title: 'Main Technologies',
            items: ['Angular1', 'Angular2'],
        } as PieceUnorderedList,
    ],
}

export default jobManagementPlatform;


// WEBPACK FOOTER //
// ./src/store/portfolio/job-management-platform.tsx